import Parent from "parentjs/controllers/app_controller.js";
export default Parent;
